import React, { Component } from 'react';
import { connect } from 'shalala';
import { Button, Row, Col } from 'react-bootstrap';

import { useStore } from '../../store';
import PacUpsertForm from './upsert/PacUpsertForm';
import Loading from '../../facturotopia/loading/Loading';
import LoadingButton from '../../facturotopia/LoadingButton';
import PageHeader from '../../support/page-header/PageHeader';
import ResponseError from '../../shared/responses/ResponseError';
import PopConfirm from '../../facturotopia/popconfirm/PopConfirm';
import ResponseResult from '../../shared/responses/ResponseResult';

class PacsUpsert extends Component {

  constructor(props) {
    super(props);

    const { data = {}} = props.location.state || {};
    const { id } = this.props.match.params;

    this.state = {
      ...this.state,
      data: !!data.id ? { ...data, hits: undefined } : { id, config: {} }
    }

    props.reset();
    props.setData({ ...data, hits: undefined });
  }

  async componentDidMount() {
    const { data } = this.state;

    if (!!data.nombre || !data.id) {
      return;
    }

    let info = await this.props.info(data.id);

    !!info && this.props.setData({
      ...info,
      hits: undefined
    });;
  }

  handleOnReset = () => {
    this.props.resetError({
      error: undefined
    });
  }

  handleOnAction = (action: string) => {
    if (action === 'cancel') {
      return;
    }

    this.props.history.replace('/admin/pacs');
  }

  handleSubmit = async (action, info) => {
    const { data } = this.props;
    const body = {
      id: undefined,
      ...data
    };

    this.props.upsert(body, data.id);
  }

  handleOnFormDataChange = (event) => {
    this.props.change(event);
  }

  renderError = () => {
    const { error } = this.props;

    return (
      <div className="result-container">
        <ResponseError
          variant="inline"
          title="Error"
          error={ error }
          onAction={ this.handleOnReset }
        />
      </div>
    );
  }

  renderResult = () => {
    const { result } = this.props;

    return (
      <div className="result-container">
        <ResponseResult
          variant="inline"
          title="Actualización exitosa"
          result={ result }
          onAction={ this.handleOnAction }
        />
      </div>
    );
  }

  render() {
    const { data, error, result, isValid, busy, fetching } = this.props;

    if (fetching) {
      return <Loading />;
    }

    return (
      <>
        <PageHeader to="/admin/pacs" text="Pacs" />

        <h5>Nuevo Pac</h5>

        <PacUpsertForm
          data={ data }
          onFormDataChange={ this.handleOnFormDataChange }
        />

        { !!error && this.renderError() }

        { !!result && this.renderResult() }

        <Row className="pb-5">
          <Col>
            <PopConfirm text="Quieres cancelar el registro actual?"
              onAction={ this.handleOnAction }
            >
              <Button type="button"
                variant="secondary"
                disabled={ busy }
                className="mr-3"
              >
                Cancelar
              </Button>
            </PopConfirm>

            <LoadingButton type="button"
              disabled={ !isValid }
              loading={ busy }
              onClick={ this.handleSubmit }
            >
              { !!data.id ? (busy ? 'Guardando...' : 'Guardar') : '' }
              { !data.id ? (busy ? 'Registrando...' : 'Registrar') : '' }
            </LoadingButton>
          </Col>
        </Row>

      </>
    );
  }
}

const mapState = (state) => {
  return {
    ...state.admin.pacs.upsert,
    fetching: state.admin.pacs.info.busy,
  };
}

const mapActions = (actions) => {
  return {
    ...actions.admin.pacs.upsert,
    info: actions.admin.pacs.info.get,
    highlight: actions.admin.pacs.list.highlight
  };
}

export default connect(useStore, mapState, mapActions)(PacsUpsert);